<div #container class="d-flex align-items-stretch" style="flex: 1" [ngClass]="{'mb-0': modalOptions.fullScreen || showInReport, 'card': !showInReport, 'report-view': showInReport}">
    <ng-container *ngIf="!showInReport">
        <div class="card-header dropdown">
            <h4 class="card-header-title">
                <img src="assets/images/icons/leaf.png" width="20px" class="me-2">
                Energy compass
            </h4>
            <div *ngIf="!options.showAsTable && primaryYear" class="energy-compass-year-legend"
                [style.--energy-compass-year-color]="dominantYearColor">
                <span class="comparison-year-entry" [class.is-placeholder]="!activeComparisonYear"
                      [attr.aria-hidden]="!activeComparisonYear">
                    <i class="comparison-year-dot"></i><span class="notranslate">{{activeComparisonYear || primaryYear}}</span>
                </span>
                <span class="calculation-year-entry">
                    <span class="year-value"><i class="primary-year-dot"></i><span class="notranslate">{{primaryYear}}</span></span>
                    <small [class.is-placeholder]="!calculationYearPinned"
                           [attr.aria-hidden]="!calculationYearPinned">Pinned</small>
                </span>
            </div>
            <button *ngIf="!modalOptions.fullScreen" type="button" class="btn" role="button" (click)="openModal()"><i class="bi bi-arrows-angle-expand"></i></button>
            <app-chart-download-button [element]="container" [tableExportAction]="downloadTable"
                                       tableExportTitle="WEii Energiekompas – volledige berekening"
                                       tableExportFileName="weii-energiekompas.xlsx"></app-chart-download-button>
            <button type="button" class="btn" role="button" (click)="toggleShowAsTable()"><i class="bi" [ngClass]="options.showAsTable ? 'bi-bar-chart-line' : 'bi-table'"></i></button>
            <button type="button" class="btn" role="button" data-bs-toggle="dropdown"
                    data-bs-auto-close="outside" aria-expanded="false">
                <i class="bi bi-three-dots-vertical"></i>
            </button>
            <app-widget-options-menu title="Display settings" [alignEnd]="true"
                                     [anchorBelowTrigger]="modalOptions.fullScreen"
                                     (change)="saveSettings()">
                <div class="dropdown-item energy-compass-setting-row">
                    <label [for]="getInputId('calculation-year')">Calculation year</label>
                    <select class="form-select form-select-sm rounded notranslate"
                            [id]="getInputId('calculation-year')"
                            [ngModel]="settings.calculationYear"
                            (ngModelChange)="setCalculationYear($event)">
                        <option [ngValue]="null">{{automaticYearOptionLabel}}</option>
                        <option *ngFor="let year of availableYears" [ngValue]="year">
                            {{yearOptionLabel(year)}}
                        </option>
                    </select>
                </div>
                <div class="dropdown-item energy-compass-setting-row">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" [id]="getInputId('compare-years')"
                               [checked]="settings.compareYears" (click)="toggleCompareYears()">
                        <label class="form-check-label" [for]="getInputId('compare-years')">Compare with</label>
                    </div>
                    <select class="form-select form-select-sm rounded notranslate"
                            [id]="getInputId('comparison-year')"
                            [ngModel]="comparisonYearSelection"
                            (ngModelChange)="setComparisonYear($event)">
                        <option *ngFor="let year of availableYears" [ngValue]="year" [disabled]="year === primaryYear">
                            {{yearOptionLabel(year)}}
                        </option>
                    </select>
                </div>
                <app-widget-options-section title="Advanced calculation options">
                    <app-weii-calculation-options
                            [availability]="calculationOptionAvailability"
                            [coverage]="calculationOptionCoverage"
                            [showTitle]="false"
                            [inputIdPrefix]="getInputId('calculation-option')">
                    </app-weii-calculation-options>
                </app-widget-options-section>
                <app-widget-options-section title="Energy labels">
                    <div class="dropdown-item">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" [id]="getInputId('show-unknown')"
                                   [checked]="settings.showUnknown" (click)="toggleShowUnknown()">
                            <label class="form-check-label" [for]="getInputId('show-unknown')">
                                <span>Show unknown </span>
                                <span class="notranslate"> ({{numberOfUnknownLocations}})</span>
                            </label>
                        </div>
                    </div>
                </app-widget-options-section>
                <app-widget-options-section title="Building types"
                        infoText="Each building type has its own WEii thresholds for the Paris Agreement and the other efficiency classes. Buildings are positioned according to the thresholds for their own building type. The numerical Y-axis is only shown when one building type is selected.">
                    <div class="dropdown-item">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" [id]="getInputId('show-all-building-types')"
                                   [checked]="settings.showAllBuildingTypes" (click)="toggleShowAllBuildingTypes()">
                            <label class="form-check-label" [for]="getInputId('show-all-building-types')">
                                Show all building types
                            </label>
                        </div>
                    </div>
                    <div *ngFor="let plottedBuildingType of plottedBuildingTypes" class="dropdown-item"
                         [class.d-none]="settings.showAllBuildingTypes">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" [id]="getInputId(plottedBuildingType.buildingTypeId)"
                                   [checked]="settings.shownBuildingTypes[plottedBuildingType.buildingTypeId]" (click)="togglePlottedBuildingType(plottedBuildingType)">
                            <label class="form-check-label" [for]="getInputId(plottedBuildingType.buildingTypeId)">
                              <span> {{plottedBuildingType.info.name}} </span>
                               <span class="notranslate"> ({{plottedBuildingType.numberOfLocations}}) </span>
                            </label>
                        </div>
                    </div>
                </app-widget-options-section>
            </app-widget-options-menu>
            <button *ngIf="modalOptions.fullScreen" type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
    </ng-container>
    <div class="chart-body pt-0 d-flex align-items-stretch mh-100 position-relative" [ngClass]="{'p-0': options.showAsTable, 'card-body': !showInReport}">
        <div *ngIf="loading" class="position-absolute top-50 start-50 translate-middle text-center text-muted">
            <div class="spinner-border spinner-border-sm mb-2" role="status" aria-hidden="true"></div>
            <div>Energy compass is loading</div>
        </div>
        <ng-container *ngIf="!loading">
        <ng-container *ngIf="showInReport else notInReport">
            <ng-container [ngTemplateOutlet]="chart"></ng-container>
            <app-energy-compass-table class="w-100 h-100 d-flex align-items-stretch flex-column"
                                      [dataProvider]="chartDataProvider" [settings]="settings" [energyLabels]="energyLabels"
                                      [visible]="true"></app-energy-compass-table>
        </ng-container>
        <ng-template #notInReport>
            <app-energy-compass-table class="w-100 h-100 d-flex align-items-stretch flex-column" [ngClass]="{'d-none': !options.showAsTable}"
                                      [dataProvider]="chartDataProvider" [settings]="settings" [energyLabels]="energyLabels"
                                      [visible]="options.showAsTable"></app-energy-compass-table>
            <ng-container *ngIf="!options.showAsTable">
                <ng-container [ngTemplateOutlet]="chart"></ng-container>
            </ng-container>
        </ng-template>
        </ng-container>
    </div>
</div>

<ng-template #chart>
    <app-scatter-chart class="chart chart-appended h-100 w-100" [xLabels]="energyLabels" [yLabels]="weiiLabels"
                       [dataProvider]="chartDataProvider" [fullScreen]="modalOptions.fullScreen"
                       [height]="modalOptions.fullScreen || showInReport ? 500 : 330"
                       [visibleBuildingTypes]="visibleBuildingTypes" [plugins]="plugins" [pluginOptions]="pluginOptions"
                       [layoutPadding]="energyCompassLayoutPadding"
                       [gridLineColor]="gridLineColor" [suggestedMinY]="suggestedMinY" [scales]="scales"
                       [deepCloneData]="false" [singleUpdateOnDataChange]="true"></app-scatter-chart>
</ng-template>
